// Campus photo for /colleges/arizona-state-university: CC BY-SA 4.0, by Beyond My Ken, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3A2021_Arizona_State_University%2C_Tempe_Campus%2C_Old_Main.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/arizona-state-university/; credited under the photo.
const photo = {
    "slug": "arizona-state-university",
    "alt": "Old Main, the red brick building with its fountain and lawn, on the Tempe campus of Arizona State University",
    "src": "/colleges/arizona-state-university/campus-1600.webp",
    "srcSmall": "/colleges/arizona-state-university/campus-800.webp",
    "srcMid": "/colleges/arizona-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/arizona-state-university/og.jpg",
    "title": "2021 Arizona State University, Tempe Campus, Old Main",
    "author": "Beyond My Ken",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3A2021_Arizona_State_University%2C_Tempe_Campus%2C_Old_Main.jpg",
    "read": "2026-10-01"
};

export default photo;
